import { render, staticRenderFns } from "./TerraIndigenaArgentina.vue?vue&type=template&id=03d35992&scoped=true&lang=pug"
import script from "./TerraIndigenaArgentina.vue?vue&type=script&lang=js"
export * from "./TerraIndigenaArgentina.vue?vue&type=script&lang=js"
import style0 from "./TerraIndigenaArgentina.vue?vue&type=style&index=0&id=03d35992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d35992",
  null
  
)

export default component.exports